"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationHistoryTranscriptCommonModelInputSourceMedium = void 0;
exports.ConversationHistoryTranscriptCommonModelInputSourceMedium = {
    Audio: "audio",
    Text: "text",
};
